<!--
 功能名称:千里眼平台(技师)-会员管理(祝福模板)
 开发人:梁高权
 创建时间:2021/03/15
 最后修改时间:2021/03/15
 -->
<template>
<div class="blessingTemplate-wrap">
  <NavBar/>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      offset="0"
    >

    <div class="blessingBox" v-for="(item,index) in list" :key="index">
      <van-field :value="item.template" rows="1" type="textarea" autosize readonly />
      <div class="line">
        <span>已有{{item.use_num}}人使用</span>
        <span style="color: #2C6BF8;" @click="memberTemplateReport(item)">使用模板</span>
      </div>
    </div>

    </van-list>
  </van-pull-refresh>
</div>
</template>

<script>
import table from '@/api/table'
export default{
  name:'blessingTemplate',
  components: {'NavBar':() => import('@/components/NavBar')},
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      param:{
        page:1,
        limit:5,
        type:1
      }
    };
  },
  methods:{
    onLoad() {

        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        table.memberTemplateList(this.param).then(response=>{
          this.list=this.list.concat(response.data.list)
          this.loading = false;
          this.param.page++
          if (this.list.length>=response.data.total_page) {
            this.finished = true;
          }
        })

    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    memberTemplateReport(item){
      table.memberTemplateReport({id:item.id}).then(response=>{
        if(response.data.result){
          this.$store.commit('updateBlessing',item.template)
          this.$router.go(-1);//返回上一层
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
 .blessingBox{
   background: #fff;
   margin: 30px 30px 0px;
   border-radius: 16px;
   padding: 35px 27px;
   .line{
     margin-top: 25px;
     display: flex;
     justify-content: space-between;
     font-size: 24px;
     font-family: PingFang SC;
     font-weight: 500;
     color: #999999;
   }
 }
</style>
